<template>
	<v-container fluid align-start ma-0 pa-2 class="container-height">
		<v-row no-gutters fill-height>
			<v-col cols="12">
				<i-card-vertical :headerTitle="menuTitle">
					<template v-slot:body>
						<v-row>
							<!--  Reservation List ---------------------------------------------------------------------------- -->
							<v-col cols="4" class="pa-1">
								<v-row>
									<i-card-top
										class="d-md-flex"
										outlined
										:useBtnList="useBtnList"
										@btnRetrieve="btnRetrieve()" 
									>
										<template v-slot:body>
											<v-row no-gutters class="center pa-2">
													<i-label :label="'Send: '" />
													<v-col cols="3">
														<v-select
															v-model="sendYn"
															:items="sendYnList"
															item-value="code"
															item-text="codeName"
															return-object
															single-line
															outlined
															dense
															@change="btnRetrieve()"
														></v-select>
													</v-col>
													<i-label :label="'Fac: '" class="pl-1"/>
													<v-col cols="4" >
														<v-select
															v-model="facDivR"
															:items="facDivRList"
															item-value="code"
															item-text="codeName"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
											</v-row>
										</template>
									</i-card-top>
								</v-row>
								<v-row no-gutters>
									<v-col cols="12" class="pt-1">
										<DxDataGrid id="epmsb100" 
											:ref="epmsb100Ref"
											class="hipGridHeight1_1"
											:data-source="reservationList" 
											:remote-operations="false" 
											:hover-state-enabled="true"
											:allow-column-resizing="true" 
											:allow-column-reordering="true"
											:row-alternation-enabled="true" 
											:show-borders="true" 
											:width="grid.width"
											:show-row-lines="true" 
											key-expr="id" 
											:focused-row-enabled="true"
											:focused-row-key= "rowIndex" 
											:auto-navigate-to-focused-row="true"	
											:column-hiding-enabled="false" 
											:sorting="{ mode: 'none' }"
											:selection="{ mode: 'none' }"
											:word-wrap-enabled="true"
											@cellPrepared="cellPrepared"
											@focused-row-changed="onFocusedRowChanged"
										> 

											<DxColumn data-field="no" caption="No" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
											<DxColumn data-field="facDivNm" caption="Factory" width="23%" data-type="string" alignment="center" :allow-editing="false"/>
											<DxColumn data-field="reqNo" width="23%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="reservation"/>
											<template #reservation>
												<div>Reservation<br>No</div>
											</template>
											<DxColumn data-field="qty" caption="Total Qty" width="23%" data-type="number" format="#,###" alignment="center" :allow-editing="false"/>
											<DxColumn data-field="reqDlyDte" caption="Req. Date" width="23%" data-type="string" alignment="center" :allow-editing="false"/>

											<DxPaging :enabled="false" :page-size="12" />
											<DxPager :visible="false" :showInfo="false" />
										</DxDataGrid>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="8" class="pa-1">
								<!-- End of Reservation List --------------------------------------------------------------------- -->
								<v-row no-gutters>
									<v-col cols="12">
										<v-row no-gutters>
											<v-col cols="12">
												<i-card-top
													class="d-md-flex"
													outlined
													:useBtnList="useBtnList2"
													:unUseBtnList="unUseBtnList2"
													@btnSave="btnSave()" @btnDelete="btnDelete()" @btnPrint="btnPrint()" @btnSendHvs="btnSendHvs()"
												>
													<template v-slot:body>
														<v-row no-gutters class="pa-2">
															<i-label :label="'Request No: '" />
															<v-col cols="3">
																<v-select
																	v-model="facDiv"
																	:items="facDivList"
																	item-value="code"
																	item-text="codeName"
																	return-object
																	single-line
																	outlined
																	dense
																></v-select>
															</v-col>
															<v-col cols="2">
																<v-text-field 
																	v-model="reqNo" 
																	dense 
																	outlined 
																	hide-details="auto"
																	readonly
																/>
															</v-col>
														</v-row>
													</template>
												</i-card-top>
											</v-col>
										</v-row>
										<v-row no-gutters>
											<v-col cols="12" class="pt-1">
												<DxDataGrid id="epmsb101" 
													:ref="epmsb101Ref"
													class="doubleListBox08"
													:data-source="epmsb101List" 
													:remote-operations="false" 
													:hover-state-enabled="true"
													:allow-column-resizing="true" 
													:allow-column-reordering="true"
													:row-alternation-enabled="true" 
													:show-borders="true" 
													:width="grid.width"
													:show-row-lines="true" 
													key-expr="id" 
													:focused-row-enabled="false"
													:column-hiding-enabled="false" 
													:sorting="{ mode: 'none' }"
													:selection="{ mode: 'none' , allowSelectAll: false }"
													:word-wrap-enabled="true"
												> 
													<DxColumn data-field="selChek" caption="Sel" data-type="boolean" width="4%" cell-template="selChkRow" :allow-editing="false" />
													<template #selChkRow = "{ data: cellInfo }">
														<DxCheckBox :value="cellInfo.value == 'Y' ? true : false"
															:onValueChanged="value => onValueChanged(value, cellInfo )"  />
													</template> 

													<DxColumn data-field="rnum" caption="No" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="shipNo" caption="Ship No" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="pntCd" caption="Paint CD" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="matlCd" caption="Material Code" width="12%" data-type="string" alignment="center" :allow-editing="false"/>
													<DxColumn data-field="matlSpec" caption="Material Spec." width="25%" data-type="string" alignment="left" :allow-editing="false"/>
													<DxColumn data-field="perCanLtr" width="6%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="literCan"/>
													<template #literCan>
														<div>Liter<br>/Can</div>
													</template>
													<DxColumn data-field="qty" width="6%" data-type="string" alignment="right" :allow-editing="true" header-cell-template="reqLiter" :set-cell-value="qtyChanged"/>
													<template #reqLiter>
														<div>Req.<br>Liter</div>
													</template>
													<DxColumn data-field="canQty" width="6%" data-type="string" alignment="right" :allow-editing="true" header-cell-template="reqCan" :set-cell-value="canQtyChanged"/>
													<template #reqCan>
														<div>Req.<br>Can</div>
													</template>
													<DxColumn data-field="estAmt" width="6%" data-type="string" alignment="right" :allow-editing="true" header-cell-template="estAmount"/>
													<template #estAmount>
														<div>Est.<br>Amount</div>
													</template>
													<DxColumn data-field="reqDlyDte" width="15%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="true" header-cell-template="requestDate"/>
													<template #requestDate>
														<div>Request<br>Dely.Date</div>
													</template>

													<DxColumn data-field="rmk" caption="Remark" width="25%" data-type="string" alignment="center" :allow-editing="true"/>

													<DxPaging :enabled="false" :page-size="12" />
													<DxPager :visible="false" :showInfo="false" />
												</DxDataGrid>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<!-- End of Reservation Detail List --------------------------------------------------------------    -->
								<v-row no-gutters>
									<v-col cols="12" class="pt-4">
										<v-row no-gutters>
											<v-col cols="12">
												<i-card-top
													class="d-md-flex"
													outlined
													:useBtnList="useBtnList3"
													@btnRetrieve="getMain3()" @btnAdd="btnAdd()"
												>
													<template v-slot:body>
														<v-row no-gutters class="pa-2">
															<i-label :label="'Ship No: '" />
															<v-col cols="2">
																<v-select
																	v-model="shipNo"
																	:items="shipNoList"
																	item-value="shipNo"
																	item-text="shipNo"
																	return-object
																	single-line
																	outlined
																	dense
																></v-select>
															</v-col>
															<i-label :label="'Material Code/Spec: '" class="pl-1" />
															<v-col cols="2">
																<v-text-field 
																	v-model="matlCd" 
																	dense 
																	outlined 
																	hide-details="auto"	
																	@input="matlCd = matlCd.toUpperCase()"																
																/>
															</v-col>
															<i-label :label="'Factory: '" class="pl-1"  />
															<v-col cols="2">
																<v-select
																	v-model="facDiv2"
																	:items="facDivList2"
																	item-value="code"
																	item-text="codeName"
																	return-object
																	single-line
																	outlined
																	dense
																></v-select>
															</v-col>
														</v-row>
													</template>
												</i-card-top>
											</v-col>
										</v-row>
										<v-row no-gutters>
											<v-col cols="12" class="pt-1">
												<DxDataGrid id="epmsb102" 
													:ref="epmsb102Ref"
													class="doubleListBox08"
													:data-source="epmsb102List" 
													:remote-operations="false" 
													:hover-state-enabled="true"
													:allow-column-resizing="true" 
													:allow-column-reordering="true"
													:row-alternation-enabled="true" 
													:show-borders="true" 
													:width="grid.width"
													:show-row-lines="true" 
													key-expr="id" 
													:focused-row-enabled="false"
													:column-hiding-enabled="false" 
													:sorting="{ mode: 'none' }"
													:selection="{ mode: 'none' , allowSelectAll: false }"
													:word-wrap-enabled="true"
												> 
													<DxColumn data-field="selChek" caption="Sel" data-type="boolean" width="4%" cell-template="selChkRow" :allow-editing="false" />
													<template #selChkRow = "{ data: cellInfo }">
														<DxCheckBox :value="cellInfo.value == 'Y' ? true : false"
															:onValueChanged="value => onValueChanged(value, cellInfo )"  />
													</template> 

													<DxColumn data-field="pntCd" width="7%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="paintCode"/>
													<template #paintCode>
														<div>Paint<br>Code</div>
													</template>
													<DxColumn data-field="nickNm" width="7%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="nickName"/>
													<template #nickName>
														<div>Nick<br>Name</div>
													</template>
													<DxColumn data-field="matlCd" width="14%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="materialCode"/>
													<template #materialCode>
														<div>Material<br>Code</div>
													</template>
													<DxColumn data-field="matlSpec" caption="Material Spec." width="65%" data-type="string" alignment="left" :allow-editing="false"/>
													<DxColumn data-field="perCanLtr" width="7%" data-type="string" alignment="center" :allow-editing="false" header-cell-template="litterCan"/>
													<template #litterCan>
														<div>Litter<br>/Can</div>
													</template>

													<DxPaging :enabled="false"  />
													<DxPager :visible="false" :showInfo="false" />
												</DxDataGrid>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</i-card-vertical>
			</v-col>
		</v-row>
	</v-container>
</template>
	
<script>
import { DxDataGrid, DxEditing, DxColumn , DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { epmsb100 , epmsb101SendYn , epmsb101 , epms7000ShipPnt , epmsb102 , epmsb100Save } from '@/api/view/hip/B/epmsb100.js'
import { reportView , getSysDate} from '@/api/view/hip/common/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getDateFormat , getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify' // message

export default {
	name: 'epmsb100',
	mixins: [baseview, BaseDataGrid],
	components: {
	ICardVertical,
	"i-card-top": iCardTop,
	DxDataGrid,
	DxColumn,
	DxEditing,
	DxDateBox,
	DxLookup,
	DxSelection,
	DxPager
},
	data() {
		return {
			menuTitle: this.$route.meta.title,
			useBtnList: ['btnRetrieve'],
			useBtnList2: ['btnSave' , 'btnDelete' , 'btnPrint' , 'btnSendHvs'],
			useBtnList3: ['btnRetrieve' , 'btnAdd'],
			unUseBtnList2: [],

			epmsb100Ref: 'epmsb100Ref',
			epmsb101Ref: 'epmsb101Ref',
			epmsb102Ref: 'epmsb102Ref',
			reservationList: [],
			epmsb101List: [],
			epmsb102List: [],

			makerCd: this.$store.state.user.makerCd,

			sendYn: '',
			sendYnList: [],
			facDivR: '',
			facDivRList: [],

			facDiv: '',
			facDivList: [],
			reqNo: '',

			facDiv2: '',
			facDivList2: [],

			shipNo: '' ,
			shipNoList: [],
			matlCd: '',

			systemDate: '',

			factPara: '',
			rowIndex: 1,
			beCont: true

		}
	},
	computed: {
		gridMainInstance() {
			return this.GetDataGrid(this.epmsb100Ref)
		},
		gridMainInstance2() {
			return this.GetDataGrid(this.epmsb101Ref)
		},
		gridMainInstance3() {
			return this.GetDataGrid(this.epmsb102Ref)
		},		
	},
	mounted() {
		this.init()
		this.gridMainInstance.option('defaultPaging', false)
		this.gridMainInstance2.option('defaultPaging', false)
		this.gridMainInstance3.option('defaultPaging', false)
	},
	methods: {
		getStrFormat(date) {
			// this.stDate = getDateFormat(date)
			// return getDateFormat(date)
		},
		init(){
			this.facDivRList = []
			this.getList()
		},
		async getList(){
			let param = {
				code: '',
				codegr: '',
				prtCode: 'SEND_YN',
				userFlag: 'Y',
				format: '45'
			}
			let param2 = {
				code: '',
				codegr: '',
				prtCode: 'FAC_DIV_R',
				userFlag: 'Y'
			}
			let param3 = {
				code: '',
				codegr: '',
				prtCode: 'FAC_DIV',
				userFlag: 'Y'
			}

			await getCmChildCode(param).then(res => {
				this.sendYnList = res.list
				this.sendYn = res.list[0]
			})

			await getCmChildCode(param2).then(res => {
				res.list.forEach(e => {
					if(this.makerCd === '90263'|| this.makerCd === '95987'){
						if(e.codeName != 'Others'){
							this.facDivRList.push(e)
						}
					}else {
						if(e.codeName === 'Others'){
							this.facDivRList.push(e)
						}
					}
				})
				this.facDivR = this.facDivRList[0]
			})
			await getCmChildCode(param3).then(res => {
				//this.facDivList2.push({code: '0' ,codeName: ''})
				res.list.forEach(e => {
					if(this.makerCd === '90263'|| this.makerCd === '95987'){
						if(e.codeName != 'Others'){
							this.facDivList.push(e)
							this.facDivList2.push(e)
						}
					}else {
						if(e.codeName === 'Others'){
							this.facDivList.push(e)
							this.facDivList2.push(e)
						}
					}
				})
				
				this.facDiv = this.facDivList[0]
				this.facDiv2 = this.facDivList2[0]
				
				
			})
			await epms7000ShipPnt(param).then(res => {
				this.shipNoList.push({shipNo: ''})
				res.list.forEach(e => {
					this.shipNoList.push(e)
				});
			})

			await getSysDate(param).then(res => {
				this.systemDate = res.list[0].aftDate

			})

			this.getMain()
			this.getMain3()
		},
		async getMain(){
			this.reservationList = []
			try {
				this.openLoading('searching')
				let param = {
					makerCd: this.makerCd,
					sendYn: this.sendYn.code,
					facDivR: this.facDivR.code,
				}				
				await epmsb100(param).then(res => {
					let cnt = 1;
					if(res.list.length){
						res.list.forEach(e => {
							//console.log(e)
							e.id = cnt++
						});
						this.reservationList = res.list
						this.reqNo = this.reservationList[0].reqNo
						this.factPara = this.reservationList[0].facDivR	
						
						this.rowIndex = 1		

						if (this.factPara === '2') {
							this.facDiv = { code: '2', name: "Van Thai" }
						} else if(this.factPara === '1') {
							this.facDiv = { code: '1', name: "Suoi Dau" }
						}else if(this.factPara === '3'){
							this.facDiv = this.facDivList[0]
						}
						
						this.sendYnGbn()
						this.getMain2()
					} else {
						this.reservationList = []
						this.epmsb101List = []
						this.facDiv = this.facDivList[0]
						this.reqNo = ""
					}
				})
			}finally {
				this.endLoading()
			}
		},
		async getMain2(){
			this.epmsb101List = []
			try {
				// let gbn = this.makerCd
				// if(this.facDivR.code === '2'){
				// 	gbn = '9115'
				// }
				this.openLoading('searching')
				let param = {
					makerCd: this.factPara === '2' ? '9115' : this.makerCd,
					reqNo: this.reqNo,
				}
				//console.log(param)
				await epmsb101(param).then(res => {
					if(res.list.length){
						res.list.forEach(e => {
							e.id = e.rnum
							e.selChek = 'N'
						});
						this.epmsb101List = res.list
					}
				})
			}finally {
				this.endLoading()
			}
		},
		async getMain3() {
			this.epmsb102List = []
			try {
				this.openLoading('searching')
				let param = {
					shipNo: !this.shipNo.shipNo ? '' : this.shipNo.shipNo,
					matlCd: this.matlCd,
				}				
				await epmsb102(param).then(res => {
					if(res.list.length){
						res.list.forEach(e => {
							e.id = e.rnum
							e.selChek = 'N'
						});
						this.epmsb102List = res.list
					}
				})
			}finally {
				this.endLoading()
			}
		},
		btnRetrieve(){
			this.reservationList = []
			this.epmsb101List = []
			this.epmsb102List = []
			this.getMain().finally(() => {
            if (!this.reservationList.length) {                   
                   
                } else {
                    this.rowIndex = 1
                }
            })
			//this.rowIndex = 1
			this.getMain3()
		},
		onFocusedRowChanged(e) {
			this.rowIndex = e.component.option('focusedRowKey');
			
			this.reqNo = e.row.data.reqNo

			this.factPara = e.row.data.facDivR

			if (this.factPara === '2') {
				this.facDiv = { code: '2', name: "Van Thai" }
			} else {
				this.facDiv = { code: '1', name: "Suoi Dau" }
			}

			this.getMain2()
		},
		async sendYnGbn(){
			let param = {
				reqNo: this.reqNo,
				facDivR: this.factPara
			}
			
			await epmsb101SendYn(param).then(res => {
				this.unUseBtnList2 = []
				if(res.list.length){
					if(res.list[0].tcnt != '1'){
						this.unUseBtnList2.push('btnSave')
					}
				}
			})
		},
		async btnSave() {
			this.beCont = true
			if(this.sendYn.code === '2'){
				this.vToastify(this.$t('You sent this request. Cannot Modify!'), 'warn')
				return
			}
			await this.gridMainInstance2.saveEditData()
			 var row = await this.gridMainInstance2.getSelectedRowsData()
			//let row = this.epmsb401List

			if (!row.length) {
				this.vToastify(this.$t('You not select data to save!!!'), 'warn')
				return
			}

			row.forEach(e => {
				if(e.qty === '0'|| !e.qty){
					this.vToastify(this.$t('Please check request quantity!!!'), 'warn')
					this.beCont = false
				}
				if(e.reqDlyDte < dayjs(this.systemDate).format('YYYY-MM-DD')){
					this.vToastify(this.$t('Please check Request Delivery Date. Must be >=today() + 45!!!'), 'warn')
					this.beCont = false
				}
				e.reqDlyDte = dayjs(e.reqDlyDte).format('YYYY-MM-DD')
				e.facDivR = this.facDivR.code
				e.makerCd = this.factPara === '2' ? '9115' : this.makerCd
				e.userId = this.$store.state.user.userId
			});

			if (this.beCont) {
				try {
					this.openLoading('searching')
					epmsb100Save(row).then(res => {
						if(res.body === 'Y'){
							notify(this.$t('Saving is completed.'), 'success', 3000)
							this.getMain()
							this.getMain3()
						} else {
							this.vToastify(this.$t(res.body), 'warn')
						}
					})
					.catch(error => {
						this.endLoading()
					})
				} finally {
					this.endLoading()
				}
			}
		},
		async btnDelete(){
			if(this.sendYn.code === '2'){
				this.vToastify(this.$t('You sent this request. Cannot delete!'), 'warn')
				return
			}
			await this.gridMainInstance2.saveEditData()
			var selectedMainRows = await this.gridMainInstance2.getSelectedRowsData()

			if (!selectedMainRows.length) {
				this.vToastify(this.$t('Data not select!'), 'warn')				
				return				
			}

			for(var row of selectedMainRows){
				row.facDivR = this.facDivR.code
				row.makerCd = this.factPara === '2' ? '9115' : this.makerCd
				row.userId = this.$store.state.user.userId
				row.sendYn = 'D'
			}

			try {
				this.vToastifyPrompt(
					this.$t('Are you sure for deleting the selected rows?'),
					'info',
					current => {
						epmsb100Save(selectedMainRows).then(res => {
							if(res.body === 'Y'){
								notify(this.$t('Deleting is completed.'), 'success', 3000)
								this.getMain()
								this.getMain3()
							} else {
								this.vToastify(this.$t(res.body), 'warn')
							}
						})
						.catch(error => {
							this.endLoading()
						})
					},
					null,
					true
				)
			} finally {
				this.endLoading()
			}
		},
		async btnPrint(){
			this.beCont = true
			let maker = this.makerCd
			if(this.facDiv.code === '2'){
				maker = '9115'
			}
			if(this.sendYn.code === '1'){
				if(this.epmsb101List.length > 0){
					for(let i = 0; i < this.epmsb101List.length; i++ ){
						if(this.epmsb101List[i].qty === '0'){
							this.vToastify(this.$t('Please check request quantity!!!'), 'warn')
							this.beCont = false
						}
						if(this.epmsb101List[i].reqDlyDte < dayjs(this.systemDate).format('YYYY-MM-DD')){
							this.vToastify(this.$t('Please check Request Delivery Date. Must be >= today() + 45!!!'), 'warn')
							this.beCont = false
						}
					}
				}
			}
			if (this.beCont) {
				const param = {
					fileName: 'epmsb100.jrxml',
					as_req_no: this.reqNo,
					as_maker_cd: maker,
				}
				this.openLoading('searching')
				reportView(param)
				.finally(() => {
					this.endLoading()
				})
			}
		},
		async btnSendHvs(){
			this.beCont = true
			if(this.sendYn.code === '2'){
				this.vToastify(this.$t('You sent this request!'), 'warn')
				return
			}
			await this.gridMainInstance2.saveEditData()
			let row = this.epmsb101List

			row.forEach(e => {
				if(e.qty == '0'){
					this.vToastify(this.$t('Please check request quantity!!!'), 'warn')
					this.beCont = false
				}
				if(e.reqDlyDte < dayjs(this.systemDate).format('YYYY-MM-DD')){
					this.vToastify(this.$t('Please check Request Delivery Date. Must be >=today() + 45!!!'), 'warn')
					this.beCont = false
				}
				e.facDivR = this.facDivR.code
				e.makerCd = this.factPara === '2' ? '9115' : this.makerCd
				e.userId = this.$store.state.user.userId
				e.sendYn = 'S'
			});

			if (this.beCont) {
				try {
					this.vToastifyPrompt(
						this.$t('Are you sure to send HVS?'),
						'info',
						current => {
							epmsb100Save(row).then(res => {
								if(res.body === 'Y'){
									notify(this.$t('Sending task is completed.'), 'success', 3000)
									this.getMain()
								} else {
									this.vToastify(this.$t(res.body), 'warn')
								}
							})
							.catch(error => {
								this.endLoading()
							})
						},
						null,
						true
					)
				} finally {
					this.endLoading()
				}
			}
		},
		async btnAdd(){
			this.beCont = true
			if(this.facDiv2.code === '0' && (this.makerCd === '90263'|| this.makerCd === '95987')){
				this.vToastify(this.$t('Please select Request Factory'), 'warn')
				return
			}
			if(!this.epmsb102List.length){
				return
			}
			await this.gridMainInstance3.saveEditData()
			var selectedMainRows = await this.gridMainInstance3.getSelectedRowsData()
			
			if(!selectedMainRows.length){
				this.vToastify(this.$t('Data is not selected.'), 'warn')
				return
			}
			for(var row of selectedMainRows){
				row.facDivR = this.facDiv2.code
				row.makerCd = this.makerCd
				row.userId = this.$store.state.user.userId
				row.sendYn = 'N'
				row.shipNo = this.shipNo.shipNo
				row.qty = !row.qty ? '0' : row.qty
				row.estAmt = !row.estAmt ? '0' : row.estAmt
				row.canQty = !row.canQty ? '0' : row.canQty
				row.perCanLtr = !row.perCanLtr ? '0' : row.perCanLtr
			}

			
				this.openLoading('searching')
				this.vToastifyPrompt(
					this.$t('Do you want to add new request for the selected rows?'+'<br>'+'Yes: Create New Request. '+'<br>' +'Cancel: Add New Material to Present Request.'),
					'info',
					current => {
						try {
							//ADDNEW
							for(var row of selectedMainRows){
								row.reqNo = 'New'
							}
							epmsb100Save(selectedMainRows).then(res => {
								if(res.body === 'Y'){
									notify(this.$t('Sending task is completed.'), 'success', 3000)
									this.btnRetrieve()
								} else {
									this.vToastify(this.$t(res.body), 'warn')
								}
							})
							.catch(error => {
								this.endLoading()
							})
						} finally {
						this.endLoading()
					}
					},
					current => {
						try {
							//ADD
							if(this.sendYn.code == '2'){
								this.vToastify(this.$t('You sent this request. Cannot Add more!'), 'warn')
								this.endLoading()
								return
							}
							if(this.facDiv.code != this.facDiv2.code){
								this.vToastify(this.$t('Factory is different. Please check again.'), 'warn')
								this.endLoading()
								return
							}
							for(var row of selectedMainRows){
								row.reqNo = this.reqNo
							}
							epmsb100Save(selectedMainRows).then(res => {
								if(res.body === 'Y'){
									notify(this.$t('Sending task is completed.'), 'success', 3000)
									this.btnRetrieve()
								} else {
									this.vToastify(this.$t(res.body), 'warn')
								}
							})
							.catch(error => {
								this.endLoading()
							})
						} finally {
							this.endLoading()
						}
					},
					true
				)			

		},
		cellPrepared(e){
			if(e.rowType === 'data'){
				e.cellElement.style.cursor = 'pointer'
			}
		},
		async onValueChanged(value, cellInfo){
			cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
			if(value.value === true){
				cellInfo.component.selectRows([cellInfo.rowIndex + 1], true)
			} else {
				cellInfo.component.deselectRows([cellInfo.rowIndex + 1])
			}
		},
		qtyChanged(newData , value , currentRowData){
			for(let i = 0; i < this.epmsb101List.length; i++){
				if(this.epmsb101List[i].id === currentRowData.id){
					this.epmsb101List[i].qty = value
					this.epmsb101List[i].canQty = Math.ceil(Number(value) / Number(this.epmsb101List[i].perCanLtr))
				}
			}
		},
		canQtyChanged(newData , value , currentRowData){
			for(let i = 0; i < this.epmsb101List.length; i++){
				if(this.epmsb101List[i].id === currentRowData.id){
					this.epmsb101List[i].canQty = value
					this.epmsb101List[i].qty = Math.ceil(Number(value) * Number(this.epmsb101List[i].perCanLtr))
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
</style>